<template>
  <div class="StoryTagsList flex flex-wrap gap-2">
    <span
      v-for="tag in tags"
      :key="tag.id"
      :class="tagClass"
    >
      {{ tag.title }}
    </span>
  </div>
</template>

<script>
/**
 * @module StoryTagsList
 */
export default {
  name: 'StoryTagsList',

  props: {
    tags: {
      type: Array,
      default: () => ([])
    },
    tagClass: {
      type: String,
      default: ''
    }
  }
}
</script>
